import { lastRefreshedAbsoluteFormatter } from '@tableau/metrics-engine';
import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../gen-src/Localize';

export const MetricRefreshTime = (props: { lastRefreshedTimestamp?: Date }): JSX.Element => {
  return (
    <div style={lastUpdatedStyle} aria-label={Messages.ariaLabelLastRefresh()}>
      {props.lastRefreshedTimestamp
        ? lastRefreshedAbsoluteFormatter(props.lastRefreshedTimestamp)
        : Messages.notUpdated()}
    </div>
  );
};

const { Colors } = TabStyles;
const lastUpdatedStyle: React.CSSProperties = {
  color: Colors!.L9,
  fontSize: '12px',
};
